// import { fetchAll } from '../services/bar';
import { createStore } from '@souche-f2e/muji';
import { fetchDocsBar } from '../services/docs';

export default createStore({
  state: {
    // menuItems: [],
    selectedKeys: [],
    openKeys: [],
    // findList: [],
    groups: [],
    groupMap: {},
    isLogin: true
  },
  reducers: {
    SELECT(state, { url, groupId }) {
      if (url === '/docs') {
        return {
          ...state,
          selectedKeys: [],
          openKeys: []
        }
      }

      if (url[url.length - 1] === '/') {
        url = url.slice(0, url.length - 2);
      }

      const urlShorts = url.split('/');

      const id = urlShorts.pop();
      const idType = urlShorts.pop();

      let selectedKeys;
      let openKeys;

      if (idType === 'api') {
        selectedKeys = [`${id}`];
        openKeys = [groupId];
      } else if (idType === 'group') {
        selectedKeys = [];
        openKeys = [id || groupId];
      } else {
        return state;
      }

      return {
        ...state,
        selectedKeys: selectedKeys,
        openKeys: openKeys
      };
    },

    UPDATE_BAR(state, { groups = [] }) {
      // SiderMenu 处理逻辑
      // const items = groups.map(group => ({
      //   title: group.name,
      //   key: group.id + '',
      //   children: group.apis.map((api) => ({
      //     title: api.name,
      //     key: `${api.id}`,
      //     path: `/documents/docs/api/${api.id}?groupId=${group.id}`
      //   }))
      // }));


      const subMenus = groups.map(group => ({ name: group.name, key: group.id + '' }));
      const subMenuMap = {};

      for (const group of groups) {
        subMenuMap[group.id] = group.apis.map(api => ({
          key: api.id + '',
          name: api.name,
          code: api.code,
          url: `/documents/docs/api/${api.id}?groupId=${group.id}`
        }));
      }

      // 搜索 api 逻辑
      // const findList = [];

      // const groupIds = Object.keys(subMenuMap);
      // for (const groupId of groupIds) {
      //   const apis = subMenuMap[groupId];
      //   for (const api of apis) {
      //     findList.push([api.name, api.key, groupId]);
      //     findList.push([api.code, api.key, groupId]);
      //   }
      // }

      return {
        ...state,
        // menuItems: items,
        // findList,
        groups: subMenus,
        groupMap: subMenuMap
      }
    },
    SET_LOGIN_STATUS(state, { status = true }) {
      return {
        ...state,
        isLogin: status
      }
    }
  },
  effects: {
    async fetch() {
      const body = await fetchDocsBar().promise;

      const { success, code, msg, data } = body;
      const { apis, groups } = data;

      if (success) {
        this.UPDATE_BAR({ apis, groups });
      }

      if (success === false && code === 403 && msg === '未登录') {
        this.SET_LOGIN_STATUS({ status: false });
      } else {
        this.SET_LOGIN_STATUS({ status: true });
      }
    }
  }
});
